module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "special-topic-list"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "topic-banner"
  }), _vm._v(" "), _c('div', {
    staticClass: "topic-list-wrapper"
  }, [_c('div', {
    staticClass: "topic-list-inner-wrapper"
  }, [_c('span', {
    staticClass: "topic-list-title"
  }, [_vm._v("全部专题")]), _vm._v(" "), _vm._l((_vm.data.items), function(topic) {
    return _c('div', {
      staticClass: "topic-wrapper",
      on: {
        "click": function($event) {
          _vm.toDetail(topic.id)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": ("" + (_vm.$store.state.UPLOAD_IMG_HOST) + (topic.logo))
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "topic-content-wrapper"
    }, [_c('span', {
      staticClass: "topic-title"
    }, [_vm._v(_vm._s(topic.title))]), _vm._v(" "), _c('span', {
      staticClass: "topic-duration"
    }, [_vm._v(_vm._s(_vm._f("format-date")(topic.startTime, 'YYYY-MM-DD')) + " ~ " + _vm._s(_vm._f("format-date")(topic.endTime, 'YYYY-MM-DD')))]), _vm._v(" "), _c('span', {
      staticClass: "topic-audition-person-time"
    }, [_vm._v("已有" + _vm._s(topic.candidateNum) + "人参选")]), _vm._v(" "), _c('p', {
      staticClass: "topic-desc"
    }, [_vm._v(_vm._s(topic.description))]), _vm._v(" "), (!_vm.isTopicOver(topic)) ? _c('img', {
      key: topic.id,
      staticClass: "topic-status",
      attrs: {
        "src": ((_vm.$store.state.IMG_HOST) + "topic_status_active@2x.png")
      }
    }) : _c('img', {
      key: topic.id,
      staticClass: "topic-status",
      attrs: {
        "src": ((_vm.$store.state.IMG_HOST) + "topic_status_over@2x.png")
      }
    })])])
  })], 2), _vm._v(" "), (_vm.data.pages >= 2) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.data.pageNum,
      "page-count": _vm.data.pages,
      "layout": "prev, pager, next"
    },
    on: {
      "current-change": _vm.changePage
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('xi-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ad392b6!./~/vue-loader/lib/selector.js?type=template&index=0!./views/specialTopic/List.vue
// module id = 1123
// module chunks = 0